import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Form, Input } from 'antd';
import { useEffect, useMemo } from 'react';
import { DetailInbound } from '../../Inbound/Interface';
function ShippingPlantForm({
  data,
  edit
}: {
  data?: DetailInbound;
  edit?: boolean;
}) {
  const defaultValue = useMemo(() => {
    return {
      yearETD: formatDateTime(data?.shippingPlanEtd)?.slice(0, 4),
      monthETD: formatDateTime(data?.shippingPlanEtd)?.slice(5, 7),
      dateETD: formatDateTime(data?.shippingPlanEtd)?.slice(8, 10),
      yearETA: formatDateTime(data?.shippingPlanEta)?.slice(0, 4),
      monthETA: formatDateTime(data?.shippingPlanEta)?.slice(5, 7),
      dateETA: formatDateTime(data?.shippingPlanEta)?.slice(8, 10)
    };
  }, [data]);
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue(defaultValue);
  }, [form, defaultValue]);
  const isEdit = edit ? false : true;
  return (
    <>
      <div style={{ padding: '10px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '15px'
          }}
        >
          <p>Shipping Plan</p>
        </div>

        <Form
          form={form}
          initialValues={{
            yearETD: defaultValue.yearETD,
            monthETD: defaultValue.monthETD,
            dateETD: defaultValue.dateETD,
            yearETA: defaultValue.yearETA,
            monthETA: defaultValue.monthETA,
            dateETA: defaultValue.dateETA
          }}
        >
          <div style={{ display: 'flex' }}>
            <div>
              <p>ETD</p>
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <Form.Item name="yearETD" style={{ width: '45%' }}>
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
                <Form.Item name="monthETD" style={{ width: '25%' }}>
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
                <Form.Item name="dateETD" style={{ width: '25%' }}>
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
              </div>
            </div>

            <span
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                padding: '0 10px'
              }}
            >
              ~
            </span>
            <div>
              <p>ETA</p>
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <Form.Item name="yearETA" style={{ width: '45%' }}>
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
                <Form.Item name="monthETA" style={{ width: '25%' }}>
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
                <Form.Item name="dateETA" style={{ width: '25%' }}>
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </>
  );
}

export default ShippingPlantForm;
